import React, { useContext } from "react";
import PropTypes from "prop-types";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";

const TextToCopy = ({ isDesktop }) => {
    const { state } = useContext(AssetDownloadContext);
    const { asset, assetDownloadConfig, purchaseType } = state;
    const { getHtmlAttribution } = assetDownloadConfig;
    const copyText = getHtmlAttribution(asset, purchaseType, isDesktop);
    return <copyText.jsx />;
};

export default TextToCopy;

// prop-types
TextToCopy.propTypes = {
    isDesktop: PropTypes.bool
};
